<ng-container>
    <span mat-dialog-title class="modal-header">
    <span>
      <i class="material-icons" style="font-size: 18px">filter_list</i> Share Pipeline
    </span>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </span>
  <div mat-dialog-content>
    <div class="name-row"><strong>Pipeline Name: </strong>{{data.pipeline.name}}</div>
    <div class="group-row"><strong>Pipeline Owner: </strong>
      <span>
        <mat-icon class="icon group-icon" (click)="viewGroupMembers(owner)" matTooltip="View Group Members">group</mat-icon>
        {{owner.name}}
        @if(!isOwner()){
          <mat-icon class="icon edit-icon" (click)="changeOwner()" matTooltip="Edit Owner">edit</mat-icon>
        }
        </span>
    </div>
    <div class="share-row">
      <div class="row"><strong>Share Pipeline</strong></div>
      @if(viewChangeOwnerPanel){
        <div class="row green-panel">
          <strong>Owner</strong>
          <div class="row">
            <div class="col-md-5">
              <mat-form-field class="dense-field" subscriptSizing="dynamic">
                <mat-select placeholder="Select New Owner" (selectionChange)="onOwnerChange($event)">
                  @for(option of groups; track $index){
                    <mat-option [value] = "option">{{option.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-button-toggle-group class="small-toggle" [value]="selectedOwnerType" (change)="selectedOwnerType = $event.value">
                <mat-button-toggle [value]="ShareOwnerType.GROUP">GROUP</mat-button-toggle>
                <mat-button-toggle [value]="ShareOwnerType.USER">USER</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-md-5">
          <mat-form-field class="dense-field" subscriptSizing="dynamic">
            <input matInput type="text" placeholder="Select values..."
                   [matAutocomplete]="auto"
                   [formControl]="searchControl"
            />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectShare($event)" [displayWith]="displayFn">
              @for(option of (filteredOptions | async); track $index){
                <mat-option [value]="option">{{option.name}}</mat-option>
              }
            </mat-autocomplete>
<!--            <mat-select placeholder="Select values" (selectionChange)="onSelectShare($event)">-->
<!--              @if(selectedShareType===ShareOwnerType.GROUP){-->
<!--                @for(option of groups; track $index){-->
<!--                  <mat-option [value] = "option">{{option.name}}</mat-option>-->
<!--                }-->
<!--              }-->
<!--              @if(selectedShareType===ShareOwnerType.USER){-->
<!--                @for(option of users; track $index){-->
<!--                  <mat-option [value] = "option">{{option.name}}</mat-option>-->
<!--                }-->
<!--              }-->
<!--            </mat-select>-->
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-button-toggle-group class="small-toggle" [value]="selectedShareType" (change)="changeShareType($event)">
            <mat-button-toggle [value]="ShareOwnerType.GROUP">GROUP</mat-button-toggle>
            <mat-button-toggle [value]="ShareOwnerType.USER">USER</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>
    @if(shareGroups.length){
      <div class="col group-list">
        @for(group of shareGroups; track group.id){
          <div class="row"><span><mat-icon class="icon group-icon">group</mat-icon><strong>{{group.name}}</strong><mat-icon (click)="removeShareGroupFromList(group)" class="icon delete-icon" matTooltip="Remove Group/User">delete</mat-icon></span></div>
          <div class="row">
            <div class="col-md-3">
              <mat-checkbox disabled checked>View</mat-checkbox>
            </div>
            @if(isOwner()){
              <div class="col-md-3">
                <mat-checkbox [checked]="group._edit" (change)="onEditPermissionChange($event, group)">Edit</mat-checkbox>
              </div>
              <div class="col-md-3">
                <mat-checkbox [checked]="group._delete" (change)="onDeletePermissionChange($event,group)">Delete</mat-checkbox>
              </div>
            }
          </div>
        }
      </div>
    }

  </div>
  <div mat-dialog-actions>
    <button mat-flat-button class="share-pipeline-button" (click)="sharePipeline()">SAVE PIPELINE PERMISSIONS</button>
  </div>
</ng-container>
